import "./Contact.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import ConnectWithOurHub from "./sections/ConnectWithOurHub";
import ForgingConnections from "./sections/ForgingConnections";
import OurAirportHub from "./sections/OurAirportHub";
import AviationLogisticsFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <GlobalNavigation />
      <ConnectWithOurHub />
      <ForgingConnections />
      <OurAirportHub />
      <AviationLogisticsFooter />
    </div>;
}